// extracted by mini-css-extract-plugin
export var active = "_k0-2";
export var recordingDot = "_k0-1";
export var recordingIndicator = "_k0-0";